var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaiffeisenbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1044,
    viewBox: "0 0 1440 1044",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1044,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_807_28121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1044
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1044,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_807_28121)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1364.13 292.623V395.499L1408.22 439.589L1595.61 255.882L1636.02 316.507C1600.5 195.261 1505.22 -27.7585 1408.22 50.133C1311.22 128.025 1207.36 219.754 1167.56 255.882L1202.47 303.64L1111.51 394.326L1020.55 303.64L1055.45 255.883C1015.65 219.754 911.795 128.025 814.795 50.1334C717.794 -27.7582 622.515 195.262 587 316.508L627.408 255.883L814.795 439.589L858.882 395.499V292.623L925.023 342.219L912.163 474.487L972.197 533.22L587.048 917.22L717.48 1055L1111.51 669.511L1505.54 1055L1635.97 917.22L1250.82 533.22L1310.85 474.487L1297.99 342.219L1364.13 292.623Z",
    fill: "url(#paint0_linear_807_28121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_28121",
    x1: 1255.98,
    y1: 170.479,
    x2: 901.396,
    y2: 1007.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4147",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiffeisenbg);
export default __webpack_public_path__ + "static/media/raiffeisenbg.d02f202b56c29798c9ec7d9cdec62ce8.svg";
export { ForwardRef as ReactComponent };